/*
 * Panier (/cart) : un clic sur un article ouvre sa fiche simplifiee dans une
 * modale, au lieu de quitter la page. Un visiteur arrive directement sur le
 * panier peut donc lire la description sans perdre son contexte.
 *
 * Le contenu vient de <url produit>?view=cart-modal, rendu en {% layout none %}
 * par templates/product.cart-modal.liquid : un fragment, pas une page.
 *
 * L'enveloppe est une <dialog> native — elle apporte le piege de focus, la
 * fermeture par Echap et l'inertage de l'arriere-plan sans reimplementer la
 * mecanique de tiroir du theme.
 */
(function () {
  var CART = '#main-cart-items';
  var VIEW = 'view=cart-modal';

  // Libelles traduits, poses par sections/cart-quick-view.liquid.
  var strings = {};

  var dialog = null;
  var pressDialog = null;
  var content = null;
  var cache = {};
  var currentUrl = null;

  /* ---------- Enveloppe ---------- */

  function build() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'cart-modal';
    dialog.innerHTML =
      '<div class="cart-modal__shell">' +
        '<div class="cart-modal__frame" data-cart-modal-frame>' +
          '<div class="cart-modal__content" data-cart-modal-content></div>' +
        '</div>' +
        '<button type="button" class="cart-modal__close" data-cart-modal-close autofocus>' +
          '<span class="visually-hidden"></span>' +
          '<svg class="cmp__icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4 L14 14 M14 4 L4 14"/></svg>' +
        '</button>' +
      '</div>';

    var closeLabel = strings.close || 'Fermer';
    dialog.querySelector('.cart-modal__close .visually-hidden').textContent = closeLabel;
    dialog.querySelector('[data-cart-modal-close]').setAttribute('aria-label', closeLabel);

    content = dialog.querySelector('[data-cart-modal-content]');

    dialog.addEventListener('click', function (event) {
      // Un clic sur le fond assombri vise la <dialog> elle-meme.
      if (event.target === dialog) close();
      if (event.target.closest('[data-cart-modal-close]')) close();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      currentUrl = null;
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  /* ---------- Vue agrandie d'un article de presse ---------- */

  /*
   * Une seconde <dialog> empilee sur la premiere : le navigateur gere la
   * superposition et Echap ferme d'abord celle du dessus. Elle recoit la
   * capture de l'article et, quand il y en a une, la video : le seul
   * endroit de la modale ou un lecteur tiers est admis.
   */
  function buildPress() {
    if (pressDialog) return pressDialog;

    pressDialog = document.createElement('dialog');
    pressDialog.className = 'press-modal';
    pressDialog.innerHTML =
      '<div class="press-modal__shell">' +
        '<figure class="press-modal__figure">' +
          '<img class="press-modal__image" alt="">' +
          '<div class="press-modal__video" hidden></div>' +
          '<figcaption class="press-modal__caption">' +
            '<span class="press-modal__outlet caption-with-letter-spacing"></span>' +
            '<p class="press-modal__text"></p>' +
          '</figcaption>' +
        '</figure>' +
        '<button type="button" class="press-modal__close" data-press-close>' +
          '<svg class="cmp__icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4 L14 14 M14 4 L4 14"/></svg>' +
        '</button>' +
      '</div>';

    var closeLabel = strings.close || 'Fermer';
    pressDialog.querySelector('[data-press-close]').setAttribute('aria-label', closeLabel);

    pressDialog.addEventListener('click', function (event) {
      if (event.target === pressDialog || event.target.closest('[data-press-close]')) {
        pressDialog.close();
      }
    });

    // On vide la video a la fermeture, sinon le lecteur continue de jouer
    // derriere la modale produit.
    pressDialog.addEventListener('close', function () {
      pressDialog.querySelector('.press-modal__video').innerHTML = '';
    });

    document.body.appendChild(pressDialog);
    return pressDialog;
  }

  function openPress(card) {
    var press = buildPress();
    var outlet = card.getAttribute('data-press-outlet') || '';
    var imageUrl = card.getAttribute('data-press-image');
    var image = press.querySelector('.press-modal__image');
    var video = press.querySelector('.press-modal__video');

    if (imageUrl) {
      image.setAttribute('src', imageUrl);
      image.setAttribute('alt', outlet);
      image.hidden = false;
    } else {
      image.removeAttribute('src');
      image.hidden = true;
    }

    // La video vit dans un <template> voisin de la carte : elle n'est
    // instanciee qu'ici, donc chargee seulement a l'ouverture.
    var item = card.closest('.cmp__press-item');
    var template = item ? item.querySelector('[data-press-video]') : null;
    video.innerHTML = '';
    if (template) {
      video.appendChild(template.content.cloneNode(true));
      video.hidden = false;
    } else {
      video.hidden = true;
    }

    press.querySelector('.press-modal__outlet').textContent = outlet;
    press.querySelector('.press-modal__text').textContent = card.getAttribute('data-press-text') || '';
    press.querySelector('.press-modal__shell').scrollTop = 0;

    if (!press.open) press.showModal();
  }

  /* ---------- Contenu ---------- */

  function setContent(html) {
    content.innerHTML = html;

    // innerHTML n'execute pas les scripts : on les rejoue, au cas ou une app
    // en injecterait un dans le fragment.
    content.querySelectorAll('script').forEach(function (old) {
      var script = document.createElement('script');
      Array.from(old.attributes).forEach(function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.appendChild(document.createTextNode(old.innerHTML));
      old.parentNode.replaceChild(script, old);
    });

    mountReviews();
    mountRating();
  }

  /*
   * Note sous le titre : widget compact Vitals (vital_reviews_under_title), rendu dans
   * une iframe srcdoc (comme les avis, car X-Frame-Options: DENY bloque une iframe src=).
   * Hauteur capee (une ligne) : pas de boucle de retro-action comme le bloc d'avis.
   */
  function mountRating() {
    var frame = content.querySelector('[data-cart-modal-rating]');
    if (!frame) return;
    var url = frame.getAttribute('data-rating-url');
    if (!url) return;

    frame.addEventListener('load', function () {
      var doc;
      try { doc = frame.contentDocument; } catch (error) { return; }
      if (!doc || !doc.body) return;
      var sync = function () {
        var h = Math.min(doc.documentElement.scrollHeight || 30, 70);
        frame.style.height = h + 'px';
      };
      sync();
      if (window.ResizeObserver) { new ResizeObserver(sync).observe(doc.body); }
      else { setTimeout(sync, 1200); setTimeout(sync, 3000); }
    });

    fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('HTTP ' + response.status); return response.text(); })
      .then(function (html) {
        frame.srcdoc = html.replace(/<head([^>]*)>/i, '<head$1><base href="' + window.location.origin + '/">');
      })
      .catch(function (error) { console.warn('[cart-modal] note indisponible', error); });
  }

  /*
   * Les avis arrivent dans une iframe : meme origine, donc on lit sa hauteur
   * directement et on la reporte sur le cadre. Sans cela l'iframe garderait
   * sa hauteur par defaut et les avis seraient tronques.
   */
  function mountReviews() {
    var frame = content.querySelector('[data-cart-modal-reviews]');
    if (!frame) return;

    var url = frame.getAttribute('data-reviews-url');
    if (!url) return;

    // Le widget Vitals rend TOUS les avis (plusieurs milliers -> hauteur de plusieurs
    // centaines de milliers de px), et suivre sa hauteur cree une boucle de retro-action.
    // On fixe donc une hauteur et on laisse defiler a l'interieur.
    frame.style.height = '620px';
    frame.setAttribute('scrolling', 'auto');

    // Le storefront renvoie X-Frame-Options: DENY + CSP frame-ancestors 'none' : une
    // iframe src= vers une page livlab.care est donc bloquee (elle se charge vide).
    // On recupere le HTML de la vue avis en fetch et on l'injecte via srcdoc : ce n'est
    // pas une URL framee -> ca echappe a X-Frame-Options, le HTML s'execute dans notre
    // origine (Vitals retrouve vtlsLiquidData.produit et rend ses avis). Un <base> gere
    // les URLs relatives eventuelles.
    fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        frame.srcdoc = html.replace(/<head([^>]*)>/i, '<head$1><base href="' + window.location.origin + '/">');
      })
      .catch(function (error) {
        console.warn('[cart-modal] avis indisponibles', error);
      });
  }

  function load(url) {
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + VIEW;

    if (cache[url]) {
      setContent(cache[url]);
      return;
    }

    content.innerHTML = '<div class="cart-modal__loading">' + (strings.loading || '') + '</div>';

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (currentUrl !== url) return; // l'utilisateur a ouvert autre chose entre-temps
        cache[url] = html;
        setContent(html);
      })
      .catch(function (error) {
        console.warn('[cart-modal] chargement impossible', error);
        if (currentUrl === url) {
          content.innerHTML = '<div class="cart-modal__loading">' + (strings.error || '') + '</div>';
        }
      });
  }

  function open(url) {
    build();
    currentUrl = url;
    document.documentElement.style.overflow = 'hidden';
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-cart-modal-frame]').scrollTop = 0;
    load(url);
  }

  /* ---------- Declencheurs ---------- */

  function productUrl(row) {
    var link = row.querySelector('a.cart-item__name');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }

  var config = document.getElementById('CartModalConfig');
  if (config) {
    strings = {
      close: config.getAttribute('data-close'),
      loading: config.getAttribute('data-loading'),
      error: config.getAttribute('data-error')
    };
  }

  // Delegation : la liste du panier est re-rendue a chaque changement de
  // quantite, des ecouteurs poses sur les lignes seraient perdus.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;
    if (!target || !target.closest) return;

    // Carte de presse : ouvre la capture en grand.
    var pressCard = target.closest('[data-cmp-press]');
    if (pressCard) {
      event.preventDefault();
      openPress(pressCard);
      return;
    }

    // Vignettes de la galerie, a l'interieur de la modale.
    var thumb = target.closest('[data-cmp-thumb]');
    if (thumb) {
      var index = thumb.getAttribute('data-cmp-thumb');
      content.querySelectorAll('[data-cmp-thumb]').forEach(function (button) {
        button.classList.toggle('is-active', button === thumb);
      });
      content.querySelectorAll('[data-cmp-slide]').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-cmp-slide') === index);
      });
      return;
    }

    // Cartes upsell (page /cart) : clic sur la vignette ou le titre -> meme modale
    // fiche produit. Les boutons + / - / ajouter (.hb-card__ctrl) gardent leur
    // comportement (gere par assets/upsell-products.js), on ne les intercepte pas.
    var upCard = target.closest('upsell-products .hb-card');
    if (upCard) {
      if (target.closest('.hb-card__thumb-wrap') || target.closest('.hb-card__thumb') || target.closest('.hb-card__name')) {
        var upUrl = upCard.getAttribute('data-url');
        if (upUrl) {
          event.preventDefault();
          open(upUrl.split('?')[0]);
        }
      }
      return;
    }

    var row = target.closest(CART + ' .cart-item');
    if (!row) return;

    // Le titre et la vignette ouvrent la modale ; quantite, suppression et
    // liens de fichiers joints gardent leur comportement.
    if (!target.closest('a.cart-item__name') && !target.closest('.cart-item__media')) return;

    var url = productUrl(row);
    if (!url) return;

    event.preventDefault();
    open(url);
  });
})();
